import * as React from "react";

import { cn } from "~/lib/utils";

const headingClass = {
  section:
    "font-display text-[22px] leading-[1.1] font-medium tracking-[-0.03em] text-fg-strong",
  subsection:
    "font-display text-[17px] leading-[1.2] font-medium tracking-[-0.02em] text-fg-strong",
};

export function Heading({
  level = "section",
  className,
  ...props
}: React.ComponentProps<"h2"> & { level?: keyof typeof headingClass }) {
  return <h2 className={cn(headingClass[level], className)} {...props} />;
}

export function Note({ className, ...props }: React.ComponentProps<"p">) {
  return (
    <p
      data-slot="note"
      className={cn(
        "max-w-[820px] text-label leading-normal text-pretty text-fg-muted",
        className,
      )}
      {...props}
    />
  );
}
